module.exports = __webpack_public_path__ + "img/ios-screenshot-en.32fceac0.png";